import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import SafetyPage from "../pages/safety/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";
import DisclaimerPage from "../pages/disclaimer/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en/",
    element: <Home />,
  },
  {
    path: "/fr/",
    element: <Home />,
  },
  {
    path: "/da/",
    element: <Home />,
  },
  {
    path: "/de/",
    element: <Home />,
  },
  // Article pages
  {
    path: "/allchinabuy-spreadsheet-guide/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-review/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-shipping/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-warehouse/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-coupon/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-legit/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-qc/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-shipping-cost/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-discount-code/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-sellers/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-comparison/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-buying-guide/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-beginner/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-payment/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-refund/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-parcel/",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-safety-guide/",
    element: <ArticlePage />,
  },
  // Supporting pages
  {
    path: "/about/",
    element: <AboutPage />,
  },
  {
    path: "/contact/",
    element: <ContactPage />,
  },
  {
    path: "/safety/",
    element: <SafetyPage />,
  },
  {
    path: "/privacy-policy/",
    element: <PrivacyPage />,
  },
  {
    path: "/terms/",
    element: <TermsPage />,
  },
  {
    path: "/disclaimer/",
    element: <DisclaimerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;